<template>
  <div>
    <v-info-form :title="title" @close="cancel()">
        <v-card-text>
          <v-layout column>
            <v-flex>
             Номер лицензии: <b>{{item.number}}</b>
            </v-flex>
            <v-flex>
             с <b>{{formats.blank(item.startDate, formats.formatDate)}}</b> <span v-show="item.finishDate"> по <b>{{formats.blank(item.finishDate, formats.formatDate)}}</b> </span>
            </v-flex>
            <v-flex>
              <b>{{item.activities.map(a => a.name).join(', ')}}</b>
            </v-flex>
            <v-flex>
              Выдана: <b>{{formats.blank(item.issued.date, formats.formatDate)}}</b> - {{item.issued.org}} 
            </v-flex>
            <v-flex v-show="item.paused != null">
              Приостановлена: <b>{{item.paused ? formats.blank(item.paused.date, formats.formatDate) : ''}}</b> - {{item.paused ? item.paused.org : ''}} 
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      </v-card-text>
    </v-info-form>
  </div>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import apimix from '../common/apimix'
  import vInfoForm from '../common/InfoForm'

  export default {
    name: 'v-license-form',
    mixins: [apimix],
    components: {vInfoForm},
    data: () => ({
      edit: false,
      valid: false,
      item: {}
    }),
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      model: {
        type: Object,
        default: () => {}
      }
    },
    created () {
      this.item = this.getItemNew()
    },
    mounted () {
      if (!this.model) {
        this.item = this.getItemNew()
      } else {
        this.item = this.model
      }
    },
    watch: {
      model: function (newVal, oldVal) {
        if (!newVal) {
          this.item = this.getItemNew()
        } else {
          this.item = newVal
        }
      }
    },
    computed: {
      ...mapGetters({
      }),
      title () {
        return `Лицензия ${this.item.number ? this.item.number : 'Лицензия'}`
      }
    },
    methods: {
      cancel () {
        this.edit = false
        this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      getItemNew () {
        return {
          number: null,
          startDate: null,
          finishDate: null,
          activities: [],
          locations: [],
          issued: {
            date: null,
            org: null
          },
          paused: null
        }
      }
    }

  }

</script>




// WEBPACK FOOTER //
// LicenseForm.vue?3c17590c